import styles from "./Favourites.module.scss";
import SideBar from "../../components/sideBar/SideBar";
import React, {useEffect} from "react";
import {useGetFavouritesFilmsListQuery} from "../../store/api/filmAPI";
import Footer from "../../components/footer/Footer";
import useWindowSize from "../../hooks/useWindowSize";
import Loader from "../../components/loader/Loader";
import Header from "../../components/header/Header";
import {useTranslation} from "react-i18next";
import {languageHandler} from "../../utils/helpers";
import {useDispatch} from "react-redux";
import {useAppSelector} from "../../store/store";
import MoviesList from "../search/MoviesList/MoviesList";
import useLikeClick from "../../hooks/useLikeClick";
import useFavouriteClick from "../../hooks/useFavouriteClick";
import SavedSmall from "../../components/icons/services/SavedSmall";
import {Link} from "react-router-dom";
import {ROUTES} from "../../constants/routes";
import {
  cleanUpFavouritesPage, setDataToFavouritesList, setFavouritesPage, setPrevFavouritesPage
} from "../../store/slices/favouritesList.slice";

interface IQuery {
  language: string;
  sort_by: string;
  include_video: boolean;
  "release_date_gte"?: string;
  "release_date_lte"?: string;
  search?: string;
  with_genres?: string;
}

const Favourites = () => {
  const accessToken = localStorage.getItem("accessToken");
  const userData = useAppSelector((state: any) => state.auth.userData);
  const filmList = useAppSelector((state: any) => state.favouritesList.commonList)
  const page = useAppSelector((state: any) => state.favouritesList.page)
  const prevPage = useAppSelector((state: any) => state.favouritesList.prevPage)

  const dispatch = useDispatch();
  const { windowSize } = useWindowSize();
  const { t, i18n } = useTranslation();
  const { likesList, likeHandler } = useLikeClick();
  const { favoritesList, favouritesHandler } = useFavouriteClick();

  const queryHandler = () => {
    const query: IQuery = {
      language: languageHandler(i18n.language) as string,
      sort_by: "popularity.desc",
      include_video: true,
    };
    return query;
  };

  const {data, isLoading, isFetching, error, refetch} = useGetFavouritesFilmsListQuery({
    mainFilter: '/movies/favorites',
    queries: {
      ...queryHandler(),
      page: page
    },
  }, { skip: !accessToken });

  useEffect(() => {
    let timeout: any;
    if (!userData?.email && accessToken) {
      timeout = setTimeout(() => {
        refetch();
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, refetch]);

  useEffect(() => {
    if ((!isFetching && data && page > prevPage) || !filmList?.length) {
      dispatch(setDataToFavouritesList(data?.results));
      dispatch(setPrevFavouritesPage(page));
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, isFetching]);


  const setPageHandler = () => {
    dispatch(setFavouritesPage(1));
  }

  useEffect(() => {
    return () => {
      dispatch(cleanUpFavouritesPage())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Header className={styles.headerWrapper} />
      {windowSize !== "mobile" ? <SideBar /> : null}
      {accessToken ? (
        <div className={styles.container}>
          <div className={styles.leftColumnWrapper}>
            <div className={styles.leftColumnTopContent}>
              <MoviesList
                data={filmList}
                error={error}
                setPageHandler={setPageHandler}
                isFetching={isFetching}
                isLastData={data.next === null}
                likeHandler={likeHandler}
                likesList={likesList?.data?.results}
                favoritesList={favoritesList?.data?.results}
                favouritesHandler={favouritesHandler}
                title={t('selected')}
                isFavoritePage={true}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.unautorisedWrapper}>
          <SavedSmall />
          <div className={styles.unautorisedTitle}>{t('loginOrReg')}</div>
          <div className={styles.unautorisedText}>{t('loginOrRegText')}</div>
          <Link to={ROUTES.LOGIN}>
            <div className={styles.unautorisedBtn}>{t('auth')}</div>
          </Link>
        </div>
      )}
      <Footer source={''}/>
    </>
  );
};

export default Favourites;
